import React from 'react';
import ReactDOM from 'react-dom';
import { sanitizeHtml } from 'javascripts/utils';

type TopbarProps = {
  enclosingElement?: HTMLElement | null;
  onClose: (e) => void;
};

export default class Topbar extends React.PureComponent<
  React.PropsWithChildren<TopbarProps>
> {
  logo: HTMLDivElement;
  logoContainer: HTMLDivElement | null;
  noteEditingMessage: HTMLDivElement;
  styles: any;

  constructor(props) {
    super(props);
    this.logo = this.findLogo();
    this.styles = {};

    const header = document.querySelector('header');
    if (document.body.classList.contains('ideas-portal') && header) {
      this.styles.backgroundColor =
        window.getComputedStyle(header).backgroundColor;
    }
  }

  findLogo() {
    let logo;

    const foundLogo =
      document.querySelector('.brand.bright') ||
      document.querySelector('.notebooks-logo');
    if (foundLogo) {
      logo = foundLogo.cloneNode(true);
    } else {
      const originalLogo = document.querySelector<HTMLDivElement>('.logo');
      if (!originalLogo) return null;
      logo = originalLogo.cloneNode(true);
      logo.className = '';

      if (logo.tagName.toLowerCase === 'img') {
        const wrapper = document.createElement('div');
        wrapper.appendChild(logo);
        logo = wrapper;
      }

      logo.classList.add('brand', 'bright');
      originalLogo.style.visibility = 'hidden';
    }

    logo.classList.add('aha-fullscreen-logo');
    logo.setAttribute('href', '');
    return logo;
  }

  componentWillUnmount() {
    const logo = document.querySelector<HTMLDivElement>('.logo');
    if (logo) {
      logo.style.visibility = 'visible';
    }
  }

  componentDidUpdate() {
    if (this.logo) {
      this.logoContainer?.appendChild(this.logo);
    }
  }

  componentDidMount() {
    if (this.logo) {
      this.logoContainer?.appendChild(this.logo);
    }
    if (this.props.enclosingElement) {
      const noteEditingMessage = this.props.enclosingElement.querySelector(
        ':scope .note-editing'
      );
      if (noteEditingMessage) {
        this.noteEditingMessage.innerHTML = sanitizeHtml(
          noteEditingMessage.innerHTML
        );
      }
    }
  }

  render() {
    return ReactDOM.createPortal(
      <div
        className='aha-fullscreen-topbar aha-editor-fullscreen-topbar'
        style={this.styles}
        onClick={this.props.onClose}
        aria-label='Close fullscreen editor'
        role='button'
      >
        <div ref={ref => (this.logoContainer = ref)} />
        <div className='close'>
          <i className='fa-solid fa-down-left-and-up-right-to-center' />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {this.props.children}
        </div>

        <div
          ref={ref => {
            if (ref) this.noteEditingMessage = ref;
          }}
          className='note-editing pull-right'
          data-reactive-preserve='true'
        />
      </div>,
      document.body
    );
  }
}
